import { render, staticRenderFns } from "./item-show.vue?vue&type=template&id=c52bbf78&"
import script from "./item-show.vue?vue&type=script&lang=js&"
export * from "./item-show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports